<template>
  <div class="symbol-editor">
    <div class="symbol-editor__row">
      <label>Relleno</label>
      <input type="color" :value="colorHex" @input="setColorHex($event.target.value)">
      <input type="number" min="0" max="100" :value="colorOpacity" @input="setColorOpacity($event.target.value)">
      <span class="symbol-editor__unit">% opacidad</span>
    </div>

    <h4 class="symbol-editor__subtitle">Contorno</h4>
    <p class="symbol-editor__hint">Opacidad 0 en el color del relleno o del contorno los oculta por separado.</p>
    <SymbologyLineEditor :symbol="outline" @input="update({ outline: $event })" />
  </div>
</template>

<script>
import { rgbToHex, hexToRgb, defaultSymbolFor } from "@/services/layers/symbology";
import SymbologyLineEditor from "@/components/symbology/SymbologyLineEditor.vue";

export default {
  name: "SymbologyPolygonEditor",
  components: { SymbologyLineEditor },
  props: {
    symbol: { type: Object, required: true },
  },
  computed: {
    colorHex() {
      return rgbToHex(this.symbol.color);
    },
    colorOpacity() {
      const color = this.symbol.color;
      const alpha = Array.isArray(color) && color.length > 3 ? color[3] : 255;
      return Math.round((alpha / 255) * 100);
    },
    //SymbologyLineEditor exige symbol requerido: un esriSFS sembrado sin
    //outline (habitual en renderers de ArcGIS) rompería el hijo sin este default.
    outline() {
      return this.symbol.outline || defaultSymbolFor("esriGeometryPolygon").outline;
    },
  },
  methods: {
    update(patch) {
      this.$emit("input", Object.assign({}, this.symbol, patch));
    },
    setColorHex(hex) {
      const alpha = Array.isArray(this.symbol.color) && this.symbol.color.length > 3 ? this.symbol.color[3] : 255;
      this.update({ color: hexToRgb(hex).concat(alpha) });
    },
    setColorOpacity(percent) {
      const alpha = Math.round((Math.max(0, Math.min(100, Number(percent) || 0)) / 100) * 255);
      this.update({ color: hexToRgb(this.colorHex).concat(alpha) });
    },
  },
};
</script>

<style lang="scss" scoped>
.symbol-editor__row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;

  label {
    min-width: 8rem;
    margin: 0;
  }

  input[type="number"] {
    width: 5rem;
  }

  input[type="color"] {
    width: 3rem;
    padding: 0;
  }
}

.symbol-editor__unit {
  color: var(--color-ghost);
  font-size: 0.82rem;
}

.symbol-editor__subtitle {
  margin: 0.75rem 0 0.25rem;
  font-size: 0.82rem;
  font-weight: 700;
}

.symbol-editor__hint {
  color: var(--color-ghost);
  font-size: 0.82rem;
  margin: 0 0 0.4rem;
}
</style>
